import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function MediaTypesMediaTypePage(): React.ReactElement {
  const currentSecurity = useSecurity('MediaTypes', 'MediaType');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/MediaTypes/Scripts/Resources/en/res.MediaType.en.js",
        "Areas/MediaTypes/Scripts/Resources/en/Types.en.js",
        "Areas/MediaTypes/Scripts/Enums.js",
        "Areas/MediaTypes/Scripts/MediaType/Index.js"], "initMediaTypesMediaType", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
